import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Balance from "../../../../assets/Balance";
import { YourWallet } from "../../../../api/request/dashboard";

const WalletCard = () => {
  const { userDetails } = useSelector((state) => state.user);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({});

  const getWallet = async () => {
    try {
      setIsLoading(true);
      const { data } = await YourWallet(userDetails?.id);
      if (data?.success) {
        setData(data?.data);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getWallet();
  }, []);

  return (
    <div className="p-5 border-2 border-light rounded-[10px] cursor-pointer h-full">
      <div className="h-full flex flex-col items-center justify-center gap-2">
        <div className="flex justify-center items-center bg-primary-light w-[45px] h-[45px] rounded-lg">
          <Balance color="#00727D" />
        </div>
        <div className="text-center">
          <p className="text-xl">$ {data?.balance || 0}</p>
          <p className="capitalize text-gray-500">My Balance</p>
        </div>
      </div>
    </div>
  );
}

export default WalletCard
